<template>
  <div>
    <v-text-field
      box
      :label="label"
      v-model="search"
      append-icon="person_search"
      @keyup.enter="listCompanies()"
      v-if="show == 'input'"
    ></v-text-field>
    <v-select
      box
      :label="label"
      v-model="selectedCompanyId"
      clearable
      :items="items"
      v-if="show == 'select'"
    ></v-select>
  </div>
</template>

<script>
import utils from "../../shared/Utils"

export default {
  name: 'CompanySelect',
  props: {
    label: {
      type: String
    },
    search_mode: {
      type: String,
      default: 'name_in'
    },
    initial_search: {
      type: String,
      default: null
    },
    model: {
      type: String
    },
    return_document_number: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      entries: [],
      search: null,
      show: 'input',
      isLoading: false,
      selectedCompanyId: this.model
    }
  },
  computed: {
    items () {
      return this.entries.map(entry => {
        const document_number = utils.mask(entry.document_type, entry.document_number)
        const Description = `${entry.social_name} ${document_number}`
        const value = this.return_document_number ? entry.document_number : entry.id
        return {text: Description, value: value}
      })
    }
  },
  watch: {
    initial_search(newValue) {
      this.search = newValue
      this.show = 'input'
    },
    selectedCompanyId (val, old_val) {
      if (typeof(val) == 'undefined' || val == null) {
        this.emit_selected_value(null)
        this.$nextTick(()=>{ this.show = 'input' })
        return
      }

      if (typeof(old_val) == 'undefined' || old_val == null) {
        this.emit_selected_value(val)
        this.$nextTick(()=>{ this.show = 'select' })
        return
      }
      if (val != old_val) {
        this.emit_selected_value(val)
      }
    }
  },
  methods: {
    reset() {
      this.search = this.initial_search || null
      this.show = 'input'
      this.selectedCompanyId = null
      this.entries = []
      this.isLoading = false
    },
    listCompanies() {
      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true

      if (String(this.search).trim() == '') {
        return false
      }

      let search_expression = this.search

      if (this.search_mode == 'document_number_prefix') {
        const search_without_punctuation = String(this.search).trim().replace(/[./-]/g, '');
        if (search_without_punctuation.length >= 11 || search_without_punctuation.length <= 14) {
          search_expression = search_without_punctuation
        }
      }

      let successCallback = (response) => {
        this.isLoading = false

        if (response.body.data && response.body.data[0]) {
          this.entries = response.body.data
          this.selectedCompanyId = this.return_document_number ? this.entries[0].document_number : this.entries[0].id
          this.emit_selected_value(this.selectedCompanyId)
          this.$emit('onCompanyList', this.entries)
          this.show = 'select'
        }
      }

      let errorCallback = (_response) => {
        this.isLoading = false
      }

      const token = this.$cookies.get('api_token')
      const isAdmin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
      const url = isAdmin ? this.$root.urls.admin__search : this.$root.urls.customer__search
      this.$http.get(url, { params: { s: search_expression, mode: this.search_mode }, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    emit_selected_value(value) {
      if (this.return_document_number) {
        this.$emit('onDocumentNumberSelected', value)
      } else {
        this.$emit('onIdSelected', value)
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/filters/CompanySelect.vue